export var RoundStatus;
(function (RoundStatus) {
    RoundStatus["CREATED"] = "CREATED";
    RoundStatus["PAIRED"] = "PAIRED";
    RoundStatus["STARTED"] = "STARTED";
    RoundStatus["COMPLETED"] = "COMPLETED";
    RoundStatus["FINALIZED"] = "FINALIZED";
    RoundStatus["FINISHED"] = "FINISHED";
})(RoundStatus || (RoundStatus = {}));
